// --- helpers base64 ---
const normalizeB64 = (b64) => {
  if (typeof b64 !== "string")
    throw new Error(`Expected base64 string, got ${typeof b64}`);
  let s = b64.replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  return s;
};

export const b64ToBytes = (b64) =>
  Uint8Array.from(atob(normalizeB64(b64)), (c) => c.charCodeAt(0));

const bytesToStr = (bytes) => new TextDecoder().decode(bytes);

// --- PKCS#7 unpad (por si el backend usa pad) ---
const pkcs7Unpad = (buf) => {
  const pad = buf[buf.length - 1];
  if (pad < 1 || pad > 16) throw new Error("Bad PKCS#7 padding");
  for (let i = 1; i <= pad; i++) {
    if (buf[buf.length - i] !== pad) throw new Error("Bad PKCS#7 padding");
  }
  return buf.slice(0, buf.length - pad);
};

// --- importar clave AES-CBC desde base64 ---
const importKey = async (keyB64) => {
  const raw = b64ToBytes(keyB64);
  if (![16, 24, 32].includes(raw.length)) {
    throw new Error(`AES key must be 16/24/32 bytes, got ${raw.length}`);
  }
  return await window.crypto.subtle.importKey(
    "raw",
    raw,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );
};

// --- decrypt principal (AES-CBC) ---
export async function decryptData(encryptedDataB64, ivB64, keyB64) {
  const key = await importKey(keyB64);
  const iv = b64ToBytes(ivB64);
  const ct = b64ToBytes(encryptedDataB64);

  if (iv.length !== 16)
    throw new Error(`IV must be 16 bytes, got ${iv.length}`);
  // El ciphertext en CBC debe ser múltiplo de 16
  if (ct.length % 16 !== 0)
    throw new Error(
      `Ciphertext length must be multiple of 16, got ${ct.length}`
    );

  const ab = await window.crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    ct
  );
  const buf = new Uint8Array(ab);

  // Intento directo (por si no hay padding); si falla, quito PKCS#7
  try {
    return JSON.parse(bytesToStr(buf));
  } catch {
    const unpadded = pkcs7Unpad(buf);
    return JSON.parse(bytesToStr(unpadded));
  }
}
